import { type AuthUser } from "@/types"
import { create } from "zustand"
import { persist } from "zustand/middleware"

export type AuthState = {
  token: string | null
  refreshToken: string | null
  user: AuthUser | null
  mfa: { challengeId: string; otpLength: number } | null
  signIn: (params: { token: string; refreshToken?: string; user: AuthUser }) => void
  signOut: () => void
  setTokens: (params: { token: string; refreshToken: string }) => void
  startMFA: (params: { challengeId: string; otpLength: number }) => void
  clearMFA: () => void
}

export const useAuth = create<AuthState>()(
  persist(
    set => ({
      token: null,
      refreshToken: null,
      user: null,
      mfa: null,

      signIn: ({ user, token, refreshToken = null }) => set({ user, token, refreshToken }),
      signOut() {
        set({ user: null, token: null, refreshToken: null, mfa: null })
      },
      setTokens: ({ token, refreshToken }) => set({ token, refreshToken }),
      startMFA: ({ challengeId, otpLength }) => set({ mfa: { challengeId, otpLength } }),
      clearMFA: () => set({ mfa: null }),
    }),
    {
      name: "jit",
    }
  )
)
